import { Button } from "@mui/material";
import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Badge from "shared/Badge/Badge";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import { RootState } from "store";
import moment from "moment";

const VoucherCard: any = ({ className = "", item, action }: any) => {
  const { t } = useTranslation();

  const voucher = useSelector((state: RootState) => state.price.voucher);

  const [count, setCount] = useState<number>(voucher?.["voucher"]?.["voucher_id"] == item?.voucher_id ? Number(voucher?.["appliedCount"]) : 0);

  const renderSliderGallery = () => {
    return (
      <div className="flex-shrink-0 p-3 w-full sm:w-64">
        <div
          className="w-full h-[200px] rounded-2xl overflow-hidden will-change-transform"
          style={{
            backgroundColor: !item?.isAvailable ? "rgb(209, 213, 219)" : !item?.discount_type ? "rgb( 45, 212, 191)" : "rgb(199, 210, 254)",
            textAlign: "center",
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}>
          <p className="text-6xl" style={{ color: "#fff", marginBottom: "3.5%" }}>
            {item?.value}
          </p>
          <p className="text-2xl" style={{ color: "#fff" }}>
            OFF
          </p>
        </div>
      </div>
    );
  };

  const renderTienIch = () => {
    return (
      <>
        <div className=" grid-cols-3 gap-2">
          {/* ---- */}
          <div className="flex items-center space-x-2" style={{ marginBottom: 5 }}>
            <span className="text-xs text-neutral-500 dark:text-neutral-400">@{item?.voucher_code}</span>
          </div>
          <div className="flex items-center space-x-2" style={{ marginBottom: 5 }}>
            <span className="text-xs text-neutral-500 dark:text-neutral-400">使用期限： {!item?.isAvailable && item?.expired_at}</span>
          </div>
          {item?.isAvailable && (
            <>
              {item?.expired_list?.map((exp: any, index: number) => {
                const isAlmostExpired = moment(exp?.expired_at).diff(moment(), "days") <= 30;

                return (
                  <>
                    <span key={index} className="text-xs text-neutral-500 dark:text-neutral-400" style={isAlmostExpired ? { color: "#FF5656", fontWeight: "bold" } : {}}>
                      {exp?.expired_count} x {exp?.expired_at} {isAlmostExpired && "(即將到期)"}
                    </span>
                    <br />
                  </>
                );
              })}
              <br />
            </>
          )}

          <div className="flex items-center space-x-2">
            <span className="text-xs text-neutral-500 dark:text-neutral-400">適用於 : {item?.is_allow_free_to_apply_text}</span>
          </div>
        </div>
      </>
    );
  };

  function renderContent() {
    const isDisabled = !item?.isAvailable || item?.quantity <= 0 || count <= 0 || count > item?.quantity || !count;

    console.log("count : ", count);

    return (
      <div className="flex-grow p-3 sm:pr-6 flex flex-col items-start">
        <div className="space-y-4 w-full">
          <div className="inline-flex space-x-3">
            <Badge
              name={
                <div className="flex items-center">
                  <i className="text-sm las la-clock"></i>
                  <span className="ml-1">{item?.is_never_expire ? "永久" : "特定期限"}</span>
                </div>
              }
              color={item?.is_never_expire ? "green" : "yellow"}
            />
            <Badge
              name={
                <div className="flex items-center">
                  <i className={`text-sm las ${item?.is_allow_free_to_apply ? "la-lock-open" : "la-lock"}`}></i>
                  <span className="ml-1">{item?.is_allow_free_to_apply ? "不設使用期限" : "只適用於特定時段"}</span>
                </div>
              }
              color={item?.is_allow_free_to_apply ? "green" : "yellow"}
            />
          </div>
          <div className="flex items-center space-x-2">
            {/* {isAds && <Badge name="ADS" color="green" />} */}
            <h2 className="text-lg font-medium capitalize">
              <span className="line-clamp-2">{item?.voucher_name}</span>
            </h2>
          </div>
          {renderTienIch()}
          <div className="w-14 border-b border-neutral-100 dark:border-neutral-800 "></div>
          <div className="flex w-full justify-between items-end">
            {/* <StartRating reviewCount={reviewCount} point={reviewStart} /> */}
            <span
              className={`flex h-[45px] items-center justify-center px-3 py-2 border ${item?.isAvailable ? "border-secondary-500" : "border-neutral-500"} rounded leading-none text-base font-medium  ${
                item?.isAvailable ? "text-secondary-500" : "text-neutral-500"
              }`}
              style={{ borderRadius: 10 }}>
              {item?.is_applied}
              {item?.isAvailable && <>數量：{item?.quantity}</>}
            </span>
            {action !== null && item?.isAvailable && (
              <div>
                <span className="text-xs text-neutral-500 dark:text-neutral-400">請輸入使用數量：</span>
                <div style={{ display: "flex", height: "45px", borderWidth: 1, borderColor: !isDisabled ? "#5046E5" : "#DADADA", borderRadius: 10, overflow: "hidden" }}>
                  <Input
                    style={{ height: "100%", borderRadius: 0, borderWidth: 0 }}
                    type="number"
                    min={0}
                    max={Number(item?.quantity)}
                    value={String(count)}
                    onChange={(e) => {
                      setCount(Math.abs(parseInt(e.target.value)));
                    }}></Input>
                  <Button
                    disabled={isDisabled}
                    style={{ backgroundColor: !isDisabled ? "#5046E5" : "#DADADA", borderRadius: 0, color: "#fff" }}
                    onClick={() => {
                      action(item, count);
                    }}>
                    使用
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`nc-PropertyCardH group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-3xl overflow-hidden shadow-xl transition-shadow ${className}`}
      data-nc-id="PropertyCardH"
      style={{ backgroundColor: !item?.isAvailable ? "rgb(243, 244, 246)" : "", marginBottom: 20 }}>
      <div className="h-full w-full flex flex-col sm:flex-row sm:items-center">
        {renderSliderGallery()}
        {renderContent()}
      </div>
    </div>
  );
};

export default VoucherCard;
